<template lang="pug">
  v-form(ref="form")
    v-container
      v-subheader 必填欄位
      v-layout(wrap)
        v-flex(xs12 sm6)
          v-text-field(v-model="form.name"
            :rules="textRequiredRules"
            label="店舖名稱"
            counter="30"
            outline
            required)
        v-flex(xs12 sm6)
          v-text-field(v-model="form.products"
            :rules="textRequiredRules"
            label="營業項目"
            counter="30"
            outline
            required)
        v-flex(xs12 sm6)
          v-text-field(v-model="form.principal"
            :rules="textRequiredRules"
            label="負責人"
            counter="30"
            outline
            required)
        v-flex(xs12 sm6)
          v-combobox(v-model="form.tags"
            :rules="arrayRequireRules"
            label="標籤"
            multiple
            chips
            outline
            required)
        v-flex(xs12 sm6)
          v-slider(
            v-model="form.order"
            :rules="requireRules"
            thumb-label="always"
            min="1"
            max="10"
            always-dirty
            ticks
            required) 優先順序
        v-flex(xs12 sm6)
          v-switch(v-model="form.disabled"
            :false-value="true"
            :true-value="false"
            :label="form.disabled ? '下架中' : '上架中'")
      v-divider
      v-subheader 選填欄位
      v-layout(wrap)
        v-flex(xs12 sm6)
          v-text-field(v-model="form.address"
            label="地址"
            outline)
        v-flex(xs12 sm6)
          v-text-field(v-model="form.phoneNumber"
            :rules="lengthRules"
            label="電話"
            counter="30"
            outline)
        v-flex(xs12 sm6)
          v-text-field(v-model="form.openTime"
            :rules="lengthRules"
            label="營業時間"
            outline
            counter="30")
        v-flex(xs12 sm6)
          v-text-field(v-model="form.link"
            label="網站連結"
            outline)
        v-flex(xs12 sm6)
          v-textarea(v-model="form.introduction"
            :rules="[v => (v || '').length <= 400 || '最多400字']"
            label="介紹"
            outline
            counter="400")
      v-divider
      v-subheader 圖片上傳
      image-editor(
        v-model="form.images"
        @update="form.images = $event")
</template>
<script>
import ImageEditor from "@/components/core/ImageEditor.vue";

export default {
  name: "ShopForm",
  components: {
    ImageEditor
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    data: {
      type: [Object, null],
      default: null
    }
  },
  data() {
    return {
      form: this.initForm(),
      requireRules: [v => !!v || "此欄位必填"],
      arrayRequireRules: [v => (v || []).length > 0 || "此欄位必填"],
      textRequiredRules: [
        v => !!v || "此為必填欄位",
        v => (v || "").length <= 30 || "最多30字"
      ],
      lengthRules: [v => (v || "").length <= 30 || "最多30字"]
    };
  },
  watch: {
    data() {
      this.initForm();
    }
  },
  methods: {
    initForm() {
      const defaultForm = {
        name: null,
        address: null,
        phoneNumber: null,
        products: null,
        openTime: null,
        principal: null,
        tags: [],
        images: [],
        link: null,
        order: 5,
        introduction: null,
        disabled: false
      };
      return (this.form = Object.entries(defaultForm).reduce(
        (acc, [field, val]) => {
          acc[field] = this.data
            ? this.data[field] === undefined
              ? val
              : this.data[field]
            : val;
          return acc;
        },
        {}
      ));
    },
    submit() {
      if (this.$refs.form.validate()) {
        return this.form;
      }
    },
    reset() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    }
  }
};
</script>
